"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDropdownHeading = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DropdownHeadingMixin = require("../../mixins/components/DropdownHeadingMixin");
var _Flex = require("../Flex/Flex");
var StyledDropdownHeading = /*#__PURE__*/(0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "StyledDropdownHeading",
  componentId: "c11n-8-107-0__sc-i8acda-0"
})(["", ""], _DropdownHeadingMixin.DropdownHeadingMixin);
exports.StyledDropdownHeading = StyledDropdownHeading;